/**
 * Render a stored coefficient without its trailing zeros: '5.0000' -> '5', '1.5000' -> '1.5'.
 *
 * The API sends a fixed 4-decimal string, which reads as noise in a table where almost every
 * value is a whole number.
 */
export const formatCoefficient = (coefficient: string | null | undefined): string => {
    if (coefficient == null || coefficient === '') return '1';
    const parsed = Number(coefficient);
    return Number.isNaN(parsed) ? coefficient : String(parsed);
};
